/** @format */
import { Injectable } from '@angular/core';
import { DocumentState } from 'common-typescript/types';
import { DowngradedService, ServiceDowngradeMappings, StaticMembers } from 'sis-common';

/**
 * Owns the student-app preview-mode flag — whether the active session is viewing draft/active document
 * states alongside published ones (used when a privileged user previews unpublished plans). State lives
 * here on the Angular side; AngularJS code consumes it via the `previewMode` factory registered through
 * the {@link DowngradedService} mapping below, so the AngularJS module name `student.common.utils.previewMode`
 * stays resolvable for legacy module-dep arrays without a separate AngularJS factory file.
 */
@StaticMembers<DowngradedService>()
@Injectable({
    providedIn: 'root',
})
export class PreviewModeService {
    static downgrade: ServiceDowngradeMappings = {
        dependencies: [],
        moduleName: 'student.common.utils.previewMode',
        serviceName: 'previewMode',
    };

    private readonly documentStates: DocumentState[] = ['ACTIVE', 'DRAFT'];
    private isPreview = false;

    setPreviewMode(): void {
        this.isPreview = true;
    }

    isPreviewMode(): boolean {
        return this.isPreview;
    }

    documentStatesForPreview(): DocumentState[] {
        return this.documentStates;
    }
}
